import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Editor } from "primereact/editor";
import { Sidebar } from "primereact/sidebar";
import { Link } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import Select from 'react-select';
import { TreeSelect } from "primereact/treeselect";
import axios from "axios";
import moment from "moment";
import { triggerAlert } from "utils/CommonFunctions";
import { MultiSelect } from 'primereact/multiselect';


const AddJob = () => {
    const [visibleRightJob, setVisibleRightJob] = useState(false);
    const [jobtitle, setJobtitle] = useState("");
    const [jobnumber, setJobNumber] = useState("");
    const [expyears, setExpyears] = useState("");
    const [jobLocation, setJobLocation] = useState(null);
    const [jobLocations, setJobLocations] = useState([]);
    const [jobStartDate, setJobStartDate] = useState(null);
    const [jobEndDate, setJobEndDate] = useState(null);
    const [skillsOptions, setSkillsOptions] = useState([]);
    const [selectedPrimarySkills, setSelectedPrimarySkills] = useState([]);
    const [userids, setUserids] = useState("");
    const [text, setText] = useState("");
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [selectedPerson, setSelectedPerson] = useState(null);
    const [personOptions, setPersonOptions] = useState([]);
    const [recruiterManager, setRecruiterManager] = useState(null);
    const [recruiters, setRecruiters] = useState([]);
    const [recruiterManagerOptions, setRecruiterManagerOptions] = useState([]);
    const [recruiterOptions, setRecruiterOptions] = useState([]);
    const [selectedCategoryKey, setSelectedCategoryKey] = useState(null);
    const [categories, setCategories] = useState([]);
    const [selectedGroupKey, setSelectedGroupKey] = useState(null);
    const [groups, setGroups] = useState([]);
    const [jobworkspaceview, setjobworkspaceview] = useState([]);
    const [jobworkspace, setjobworkspace] = useState(null);
    const [primarySkillsget, setprimarySkillsget] = useState([]);
    const [primarySkillsview, setprimarySkillsview] = useState([]);
    const [uniqueUserId, setUniqueUserId] = useState("");
    const [loggedInUserId, setLoggedInUserId] = useState(null);
    const [timeToHire, setTimeToHire] = useState("");
    const [actualEndDate, setActualEndDate] = useState(null);
    const [isPrivate, setIsPrivate] = useState(false);
    const [newErrors, setNewErrors] = useState({});

    useEffect(() => {
        const userInfo = JSON.parse(sessionStorage.getItem("user-info"));
        if (userInfo && userInfo.user_details) {
            setUniqueUserId(userInfo.user_details.unique_user_id);
            setLoggedInUserId(userInfo.user_details.user_id);
        }
    }, []);

    useEffect(() => {
        if (jobStartDate && jobEndDate) {
            const diff = moment(jobEndDate).diff(moment(jobStartDate), 'days');
            setTimeToHire(diff.toString());
        } else {
            setTimeToHire("");
        }
    }, [jobStartDate, jobEndDate]);

    const resetForm = () => {
        setJobtitle("");
        setJobNumber("");
        setExpyears("");
        setJobLocation(null);
        setJobStartDate(null);
        setJobEndDate(null);
        setSelectedPrimarySkills([]);
        setUserids("");
        setText("");
        setSelectedCompany(null);
        setSelectedDepartment(null);
        setSelectedPerson(null);
        setSelectedCategoryKey(null);
        setSelectedGroupKey(null);
        setjobworkspace(null);
        setprimarySkillsview([]);
        setTimeToHire("");
        setActualEndDate(null);
        setIsPrivate(false);
        setNewErrors({});
        setGroups([]); // Clear groups when resetting form
        setRecruiterManager(null);
        setRecruiters([]);
    };

  const handleJobSave = async (e) => {
    e.preventDefault();

    let isValid = true;
    const errors = {};

//     if (!jobnumber) {
//     errors.jobnumber = "Job Number is required.";
//     isValid = false;
//   } else if (!/^[a-zA-Z0-9_ -]*$/.test(jobnumber)) {
//     errors.jobnumber = "Please enter a valid Job ID.";
//     isValid = false;
//   }

    if (!jobtitle) {
    errors.jobtitle = "Job Title is required.";
    isValid = false;
  } else if (!/^[a-zA-Z0-9\s\-().&/]*$/.test(jobtitle)) {
    errors.jobtitle = "Only letters, numbers, spaces, and these special characters are allowed: - ( ) . & /";
    isValid = false;
  } else if (jobtitle.length < 1) {
    errors.jobtitle = "Job Title must be at least 1 character.";
    isValid = false;
  } else if (jobtitle.length > 50) {
    errors.jobtitle = "Job Title cannot exceed 50 characters.";
    isValid = false;
  }

    if (expyears) {
    if (!/^\d{1,2}$/.test(expyears)) {
      errors.expyears = "Experience in Years must be a valid number with up to 2 digits.";
      isValid = false;
    }
  }

    if (!selectedPerson) {
        errors.selectedPerson = "Hiring Manager is required.";
        isValid = false;
    }

    if (!recruiterManager) {
        errors.recruiterManager = "Recruiter Manager is required.";
        isValid = false;
    }

    setNewErrors(errors);

    if (!isValid) {
        return;
    }

    const skillsArray = Array.isArray(primarySkillsview) ? primarySkillsview : [primarySkillsview].filter(Boolean);

    // Create the payload without job_number initially
    const payload = {
        job_title: jobtitle,
        // job_number: jobnumber,
    company_id: selectedCompany?.id || null,
    // selectedPerson may be the id already depending on Dropdown optionValue; ensure we send id
    hiring_manager: typeof selectedPerson === 'object' ? selectedPerson?.id : selectedPerson || null,
    recruiting_manager: recruiterManager,
    recruiters: recruiters,
        job_posting_date: jobStartDate ? moment(jobStartDate).format("YYYY-MM-DD") : null,
        job_closing_date: jobEndDate ? moment(jobEndDate).format("YYYY-MM-DD") : null,
        job_start_date: jobStartDate ? moment(jobStartDate).format("YYYY-MM-DD") : null,
        job_end_date: jobEndDate ? moment(jobEndDate).format("YYYY-MM-DD") : null,
        workplace_types: jobworkspace || null,
        job_description: text || "",
        user_ids: uniqueUserId || "",
        categories: selectedCategoryKey ? parseInt(selectedCategoryKey) : null,
        groups: selectedGroupKey ? parseInt(selectedGroupKey) : null,
        required_skills: skillsArray.map(skill => parseInt(skill)),
        time_to_hire_days: timeToHire ? parseInt(timeToHire) : null,
        actual_end_date: actualEndDate ? moment(actualEndDate).format("YYYY-MM-DD") : null,
        archived: isPrivate,
        required_experience: expyears ? parseInt(expyears) : null,
        // jobLocation now stores { id, name, code } - send id or code based on API expectation
        location: jobLocation?.id || jobLocation?.code || null
    };

    // Only add job_number to the payload if it has a value
    // if (jobnumber) {
    //     payload.job_number = jobnumber;
    // }

    try {
        const response = await axios.post(`/api/v1/jobs/`, payload);
        triggerAlert('success', 'Success', 'Job created successfully!');
        resetForm();
        setVisibleRightJob(false);
    } catch (error) {
        console.error('Error submitting job:', error);
        const errorMessage = error.response?.data?.error || 'Failed to create job';
        triggerAlert('error', 'Error', errorMessage);
        setVisibleRightJob(false);
        resetForm();
    }
};

    const getworkspace = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-workplace-type/`);
            const transformedData = response.data.results.map((workv) => ({
                name: workv.workplace_type,
                id: workv.id,
            }));
            setjobworkspaceview(transformedData);
        } catch (error) {
            console.error('Error fetching workplace types:', error);
        }
    };

    const getskills = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-skills/`);
            const transformedData = response.data.results.map((workv) => ({
                name: workv.skill_name,
                id: workv.skill_id,
            }));
            setprimarySkillsget(transformedData);
        } catch (error) {
            console.error('Error fetching skills:', error);
        }
    };

    const getcity = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-cities/`);
            // Ensure we provide an `id` property so Dropdown with optionValue="id" returns the city id
            const transformedData = response.data.results.map((city) => ({
                name: city.name,
                id: city.city_id,
                code: city.city_id,
            }));
            setJobLocations(transformedData);
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    const getCompanydata = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-companies/`);
            const transformedData = response.data.results.map((company) => ({
                name: company.company_name,
                id: company.company_id,
            }));
            setCompanyOptions(transformedData);
        } catch (error) {
            console.error('Error fetching companies:', error);
        }
    };

    const getHirringmanager = async () => {
        try {
            const response = await axios.get(`https://qaatsapi.pranathiss.com/api/v1/get-all-hiring-managers/?status=Active`);
            const transformedData = response?.data?.results?.map((hm) => ({
                name: `${hm.first_name} ${hm.middle_name || ''} ${hm.last_name || ''}`.trim(),
                id: hm.id,
            }));
            setPersonOptions(transformedData);
            // Auto-populate if logged-in user is a hiring manager
            const matchingHM = transformedData.find(hm => hm.id === loggedInUserId);
            if (matchingHM) {
                setSelectedPerson(matchingHM.id);
            }
        } catch (error) {
            console.error('Error fetching hiring managers:', error);
            setPersonOptions([]);
        }
    };

    const getRecruiterManagers = async () => {
        try {
            const response = await axios.get(`https://qaatsapi.pranathiss.com/api/v1/users/recruiting-managers/`);
            const transformedData = response?.data?.results?.map((rm) => ({
                name: rm.full_name,
                id: rm.id,
            }));
            setRecruiterManagerOptions(transformedData);
            // Auto-populate if logged-in user is a recruiter manager
            const matchingRM = transformedData.find(rm => rm.id === loggedInUserId);
            if (matchingRM) {
                setRecruiterManager(matchingRM.id);
            }
        } catch (error) {
            console.error('Error fetching recruiter managers:', error);
            setRecruiterManagerOptions([]);
        }
    };

    const getRecruiterOptions = async () => {
        try {
            const response = await axios.get(`https://qaatsapi.pranathiss.com/api/v1/users/recruiters/`);
            const transformedData = response?.data?.results?.map((r) => ({
                name: r.full_name,
                id: r.id,
            }));
            setRecruiterOptions(transformedData);
        } catch (error) {
            console.error('Error fetching recruiters:', error);
            setRecruiterOptions([]);
        }
    };

    const transformCategoriesToTree = (categories) => {
        const buildTree = (category) => ({
            key: category.category_id,
            label: category.name,
            data: category,
            children: category.subcategories ? category.subcategories.map(buildTree) : []
        });

        return categories.map(buildTree);
    };
    const getcategoriesitemvee = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-categories/`);
            if (response.data && response.data.results) {
                const treeData = transformCategoriesToTree(response.data.results);
                setCategories(treeData);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    // Transform groups to tree structure
    const transformGroupsToTree = (groups) => {
        const buildTree = (group) => ({
            key: group.group_id,
            label: group.name,
            data: group,
            children: group.subgroups ? group.subgroups.map(buildTree) : []
        });

        return groups.map(buildTree);
    };

    const getgroupsitem = async () => {
        try {
            const response = await axios.get(`/api/v1/get-all-groups/`);
            const treeData = transformGroupsToTree(response.data.results);
            //console.log('Tree Data:', treeData); // Log the tree data
            setGroups(treeData);
        } catch (error) {
            console.error('Error fetching groups:', error);
            setGroups([]);
        }
    };

    const handlePrimarySkillsChange = (e) => {
        setprimarySkillsview(e.value || []);
    };

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
            </span>
        );
    };

    const header = renderHeader();

    const getMinEndDate = () => {
        if (!jobStartDate) return null;
        const minDate = new Date(jobStartDate);
        minDate.setDate(minDate.getDate() + 1);
        return minDate;
    };

    return (
        <React.Fragment>
            <button
                type="button"
                className="btn btn-secondary import-res-btn ms-1 me-1"
                onClick={() => {setVisibleRightJob(true);
                    getworkspace();
        getskills();
        getcity();
        getCompanydata();
        getHirringmanager();
        getRecruiterManagers();
        getRecruiterOptions();
        getcategoriesitemvee();
        getgroupsitem()
                }}
            >
                Add Job
            </button>

            <Sidebar
                visible={visibleRightJob}
                position="right"
                className="sidebar"
                onHide={() => {
                    setVisibleRightJob(false);
                    resetForm();
                }}
            >
                <div className="sidebar-header">
                    <h3>Create a Job</h3>
                    <div className="d-flex align-items-center">
                        <Link to="/jobs-editform">
                            <p className="mb-0 text-white"> <i className="fa-regular fa-pen-to-square me-3"></i> </p>
                        </Link>
                        <Button
                            icon="pi pi-times"
                            className="p-button-text close-btn"
                            onClick={() => {
                                setVisibleRightJob(false);
                                resetForm();
                            }}
                        />
                    </div>
                </div>
                <div className="card sidebardetails">
                    <form onSubmit={handleJobSave}>
                       <Row className="mb-0">
    {/* <Col lg={6}>
        <div className="p-field">
            <label htmlFor="jobNumber" className="p-d-block">Job Number<span style={{color:"red"}}>*</span></label>
            <InputText
                id="jobNumber"
                placeholder="Job Number"
                className="p-d-block w-full"
                value={jobnumber}
                onChange={(e) => setJobNumber(e.target.value)}
            />
            {newErrors.jobnumber && <small className="p-error">{newErrors.jobnumber}</small>}
        </div>
    </Col> */}
    <Col lg={6}>
        <div className="p-field">
            <label htmlFor="jobTitle" className="p-d-block">Job Title<span style={{color:"red"}}>*</span></label>
            <InputText
                id="jobTitle"
                placeholder="Job Title"
                className="p-d-block w-full"
                value={jobtitle}
                maxLength={50}
                onChange={(e) => {
                    if (/^[a-zA-Z0-9\s\-().&/]*$/.test(e.target.value)) {
                        setJobtitle(e.target.value);
                    }
                }}
            />
            {newErrors.jobtitle && <small className="p-error">{newErrors.jobtitle}</small>}
        </div>
    </Col>

    <Col lg={6}>
                                <label htmlFor="experience">Experience in Years<span style={{color:"red"}}>*</span></label>
                                <InputText
                                    inputId="experience"
                                    value={expyears}
                                    onChange={(e) => {
                                        if (/^\d*$/.test(e.target.value)) {
                                            setExpyears(e.target.value);
                                        }
                                    }}
                                    className="w-full activejobdrop"
                                    placeholder="Experience in Years"
                                    type="text"
                                    pattern="\d*"
                                />
                                {newErrors.expyears && <small className="p-error">{newErrors.expyears}</small>}
                            </Col>
</Row>

<Row className="mb-2">
    <Col lg={6}>
        <div className="p-field">
            <label htmlFor="recruiterManager">Recruiter Manager <span style={{color:"red"}}>*</span></label>
            <Dropdown value={recruiterManager} onChange={(e) => setRecruiterManager(e.value)} options={recruiterManagerOptions} optionLabel="name" optionValue="id" placeholder="Select Recruiter Manager" filter filterPlaceholder="Search Recruiter Manager" className="w-full bgclr" showClear={!!recruiterManager} />
            {newErrors.recruiterManager && <small className="p-error">{newErrors.recruiterManager}</small>}
        </div>
    </Col>
    <Col lg={6}>
        <div className="p-field">
            <label htmlFor="recruiters">Recruiters</label>
            <MultiSelect value={recruiters} onChange={(e) => setRecruiters(e.value)} options={recruiterOptions} optionLabel="name" optionValue="id" placeholder="Select Recruiters" filter filterPlaceholder="Search Recruiters" className="w-full bgclr" />
        </div>
    </Col>
</Row>

<Row className="mb-2">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="company">Company<span style={{color:"red"}}>*</span></label>
                                    <Dropdown
                                        value={selectedCompany}
                                        onChange={(e) => setSelectedCompany(e.value)}
                                        options={companyOptions}
                                        optionLabel="name"
                                        placeholder="Select Company"
                                        filter
                                        className="w-full bgclr"
                                    />
                                    {newErrors.selectedCompany && <small className="p-error">{newErrors.selectedCompany}</small>}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="hiringManager">Hiring Manager<span style={{color:"red"}}>*</span></label>
                                    <Dropdown
                                        value={selectedPerson}
                                        options={personOptions}
                                        onChange={(e) => setSelectedPerson(e.value)}
                                        optionLabel="name"
                                        optionValue="id"
                                        placeholder="Select Hiring Manager"
                                        filter
                                        filterPlaceholder="Search Hiring Manager"
                                        className="w-full bgclr"
                                        showClear={!!selectedPerson}
                                    />
                                    {newErrors.selectedPerson && <small className="p-error">{newErrors.selectedPerson}</small>}
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                           
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="jobLocation">Job Location</label>
                                    <Dropdown
                                        id="jobLocation"
                                        value={jobLocation}
                                        onChange={(e) => setJobLocation(e.value)}
                                        options={jobLocations}
                                        optionLabel="name"
                                        optionValue="id"
                                        filter
                                        filterPlaceholder="Search Location"
                                        className="w-full activejobdrop"
                                        placeholder="Select Job Location"
                                    />
                                    {newErrors.jobLocation && <small className="p-error">{newErrors.jobLocation}</small>}
                                </div>
                            </Col>

                            <Col lg={6}>
                                <label htmlFor="jobStartDate" className="p-mb-2">Job Start Date</label>
                                <Calendar
                                    id="jobStartDate"
                                    value={jobStartDate}
                                    onChange={(e) => {
                                        setJobStartDate(e.value);
                                        // Optional: Reset end date if it becomes invalid
                                        if (jobEndDate && e.value && jobEndDate <= e.value) {
                                            setJobEndDate(null);
                                        }
                                    }}
                                    dateFormat="dd/mm/yy"
                                    placeholder="dd/mm/yy"
                                    className="w-full activejobdrop"
                                    showIcon
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            
                            <Col lg={6}>
                                <label htmlFor="jobEndDate" className="mr-2">Job End Date</label>
                                <Calendar
                                    id="jobEndDate"
                                    value={jobEndDate}
                                    onChange={(e) => setJobEndDate(e.value)}
                                    minDate={getMinEndDate()}
                                    disabled={!jobStartDate}
                                    dateFormat="dd/mm/yy"
                                    placeholder="dd/mm/yy"
                                    className="w-full activejobdrop"
                                    showIcon
                                />
                            </Col>

 <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="timeToHire">Time to Hire (Days)</label>
                                    <InputText
                                        id="timeToHire"
                                        value={timeToHire}
                                        readOnly
                                        className="w-full activejobdrop"
                                        placeholder="Auto-calculated days"
                                        type="text"
                                    />
                                    {newErrors.timeToHire && <small className="p-error">{newErrors.timeToHire}</small>}
                                </div>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col lg={12}>
                            
                            <label htmlFor="primarySkills" className="mr-2">Primary Skills</label>
                            <MultiSelect
            id="primarySkills"
            value={primarySkillsview}
            onChange={handlePrimarySkillsChange}
            options={primarySkillsget}
            optionLabel="name"
            optionValue="id"
            filter
            filterPlaceholder="Search Skills"
            className="w-full activejobdrop"
            placeholder="Select Primary Skills"
        />
                            
                            {newErrors.primarySkillsview && <small className="p-error">{newErrors.primarySkillsview}</small>}
                        </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="workplaceType">Workplace Type</label>
                                    <Dropdown
                                        id="workplaceType"
                                        value={jobworkspace}
                                        onChange={(e) => setjobworkspace(e.value)}
                                        options={jobworkspaceview}
                                        optionLabel="name"
                                        optionValue="id"
                                        filter
                                        filterPlaceholder="Search Workplace Type"
                                        className="w-full activejobdrop"
                                        placeholder="Select Workplace Type"
                                    />
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="userIds">UserIDs</label>
                                    <InputText
                                        id="userIds"
                                        value={uniqueUserId}
                                        readOnly
                                        className="block w-full"
                                        placeholder="User ID"
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="categories">Categories</label>
                                    <TreeSelect
                                        value={selectedCategoryKey}
                                        onChange={(e) => {

                                            setSelectedCategoryKey(e.value);
                                        }}
                                        options={categories}
                                        className="w-full activejobdrop"
                                        placeholder="Select Categories"
                                    />
                                    {newErrors.selectedCategoryKey && <small className="p-error">{newErrors.selectedCategoryKey}</small>}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="groups">Groups</label>
                                    <TreeSelect
                                        value={selectedGroupKey}
                                        onChange={(e) => {
                                            setSelectedGroupKey(e.value);
                                        }}
                                        options={groups}

                                        className="w-full activejobdrop"
                                        placeholder="Select Groups"

                                    />
                                    {newErrors.selectedGroupKey && <small className="p-error">{newErrors.selectedGroupKey}</small>}
                                </div>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                           
                            {/* <Col lg={6}>
                                <div className="p-field">
                                    <label htmlFor="actualEndDate">Actual End Date</label>
                                    <Calendar
                                        id="actualEndDate"
                                        value={actualEndDate}
                                        onChange={(e) => setActualEndDate(e.value)}
                                        minDate={getMinEndDate()}
                                        disabled={!jobStartDate}
                                        dateFormat="dd/mm/yyyy"
                                        placeholder="dd/mm/yyyy"
                                        className="w-full activejobdrop"
                                        showIcon
                                    />
                                </div>
                            </Col> */}
                        </Row>
                        <Row className="mb-2 d-flex justify-content-between align-items-end">
                            <Col lg={6}>
                                <div className="">
                                    <label htmlFor="descriptionEditor">Description</label>
                                </div>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-end mt-2">
                                <Button color="primary" className="btn btn-primary aibtn">
                                    <i className="pi pi-star me-1"></i>
                                    Write with AI
                                </Button>
                            </Col>
                        </Row>
                        <Row className="mb-3">
                            <Col lg={12}>
                                <div className="">
                                    <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} headerTemplate={header} style={{ height: '140px' }} />
                                </div>
                            </Col>
                        </Row>
                        <Row className="justify-content-between align-items-end">
                            <Col lg={6}>
                                <div className="p-field">
                                    <Checkbox
                                        inputId="private"
                                        checked={isPrivate}
                                        onChange={(e) => setIsPrivate(e.checked)}
                                    />
                                    <label htmlFor="private">Private</label>
                                </div>
                            </Col>
                            <Col lg={6} className="d-flex justify-content-end">
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-primary sidebarbtn"
                                >
                                    Create
                                </Button>
                            </Col>
                        </Row>
                    </form>
                </div>
            </Sidebar>
        </React.Fragment>
    );
};

export default AddJob;